import React, { useState } from "react";
import './ModalPopupMessage.css';

export default function ModalPopupMessage({ option, onConfirm, onGeneral }) {
    const [isShaking, setIsShaking] = useState(false);

    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('meya-message-overlay')) {
            setIsShaking(true);
            setTimeout(() => {
                setIsShaking(false);
            }, 400);
        }
    };

    return (
        <div className='meya-message-overlay print-disable' onClick={handleOverlayClick}>
            <div className={'meya-message ' + option?.modaltype + (isShaking ? " modal-shake" : "")} >
                <div className="meya-message-body text-center" >
                    <div className={"meya-message-header " + option?.modaltype}>{option?.headers}</div>
                    <div className="meya-message-content mb-5">{option?.message}</div>
                    {
                        option?.modaltype === "modal-confirm" ?
                            <div className={"d-flex justify-content-between"}>
                                <div className="meya-message-btn btn-warning" onClick={() => onConfirm(option?.confirmcode)}>Confirm</div>
                                <div className="meya-message-btn btn-light" onClick={() => onGeneral('close')}>Cancel</div>
                            </div>
                            :
                            <div className={"d-md-flex justify-content-center"}>
                                <div className="meya-message-btn btn-light my-2" onClick={() => onGeneral('close')}>Close</div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
